import paths from './paths';
import Home from "screens/Home";
import UserProfile from "screens/UserProfile";


export default [
    {
        exact: true,
        path: paths.home,
        element: <Home />
    },
    
    {
        exact: false,
        path: paths.userProfile,
        element: <UserProfile />
    }
]